// extracted by mini-css-extract-plugin
export default {"err_container":"style_err_container__rdM+u","text":"style_text__m45zo"};